cityPipeDensity={
    "北京": 7.354344644498145,
    "天津": 17.010112912054776,
    "河北": 8.742330295506145,
    "石家庄市": 8.546680900621118,
    "晋州市": 6.700606877950102,
    "新乐市": 12.903225806451614,
    "唐山市": 9.499076305220884,
    "滦州市": 10.840273037542662,
    "遵化市": 5.321969696969697,
    "迁安市": 12.029312288613303,
    "秦皇岛市": 9.005273423390882,
    "邯郸市": 8.441368337311056,
    "武安市": 15.591960352422905,
    "邢台市": 10.126735291340069,
    "南宫市": 6.986899563318777,
    "沙河市": 12.026493799323564,
    "保定市": 6.0859487179487175,
    "涿州市": 7.449634214969049,
    "安国市": 8.038147138964577,
    "高碑店市": 14.252672497570458,
    "白沟新城": 12.359550561797754,
    "张家口市": 8.217654051912028,
    "承德市": 8.564855165342221,
    "平泉市": 6.656976744186046,
    "沧州市": 6.065025101601721,
    "泊头市": 15.002496255616574,
    "任丘市": 13.518049792531121,
    "黄骅市": 11.957104557640752,
    "河间市": 15.622009569377992,
    "廊坊市": 7.248636233132357,
    "霸州市": 8.576704545454545,
    "三河市": 17.743138270326256,
    "衡水市": 4.218812012170923,
    "深州市": 9.254716981132075,
    "辛集市": 4.081474873624739,
    "定州市": 5.135746606334841,
    "山西": 8.548677665641339,
    "太原市": 7.1375,
    "古交市": 9.18240469208211,
    "大同市": 7.212460063897764,
    "阳泉市": 9.369292604501608,
    "长治市": 17.293591905564924,
    "潞城市": 7.980952380952381,
    "晋城市": 13.284938374764991,
    "高平市": 11.123595505617978,
    "朔州市": 6.968812877263582,
    "晋中市": 5.303571428571429,
    "介休市": 5.767936226749336,
    "运城市": 10.301060606060606,
    "永济市": 3.491078355314197,
    "河津市": 5.268630849220104,
    "忻州市": 12.585612691466082,
    "原平市": 9.074534161490684,
    "临汾市": 9.808148148148147,
    "侯马市": 8.370044052863436,
    "霍州市": 15.584415584415584,
    "吕梁市": 7.995198079231692,
    "孝义市": 9.164897381457891,
    "汾阳市": 8.249999999999998,
    "内蒙古": 6.7834833203423335,
    "呼和浩特市": 3.7720384615384615,
    "包头市": 8.710685865858279,
    "乌海市": 5.874799357945426,
    "赤峰市": 8.678891298199304,
    "通辽市": 4.72224,
    "霍林郭勒市": 17.83625730994152,
    "鄂尔多斯市": 7.586408755408501,
    "呼伦贝尔市": 7.0501177262024886,
    "满洲里市": 17.474131559497415,
    "牙克石": 5.252707581227437,
    "扎兰屯市": 6.334375,
    "额尔古纳市": 7.3473282442748085,
    "根河市": 1.9400000000000002,
    "巴彦淖尔市": 7.027058823529412,
    "丰镇市": 8.9608,
    "乌兰浩特市": 6.704288939051919,
    "阿尔山市": 6.7368421052631575,
    "二连浩特": 9.222222222222221,
    "锡林浩特市": 12.538908246225319,
    "辽宁": 12.783575744181952,
    "沈阳市": 7.992089285714285,
    "新民市": 10.844444444444445,
    "大连市": 13.352286773794809,
    "瓦房店市": 14.877094972067042,
    "庄河市": 9.672897196261683,
    "鞍山市": 16.189686818859702,
    "海城市": 12.912087912087912,
    "抚顺市": 16.93575774727607,
    "本溪市": 6.376146788990826,
    "丹东市": 10.320179055247968,
    "东港市": 14.359090909090908,
    "凤城市": 17.23952380952381,
    "锦州市": 19.053177691309987,
    "凌海市": 7.939508506616257,
    "北镇市": 8.206711409395973,
    "营口市": 16.260343199866718,
    "盖州市": 9.109677419354838,
    "大石桥市": 31.434802571166205,
    "阜新市": 21.077124183006536,
    "辽阳市": 9.183652402402402,
    "灯塔市": 5.683098591549296,
    "盘锦市": 16.488913836654504,
    "铁岭市": 14.632919066383751,
    "调兵山市": 28.392612137203166,
    "开原市": 7.17078410311493,
    "朝阳市": 11.358108108108107,
    "北票市": 14.707390004271678,
    "凌源市": 22.32854864433812,
    "葫芦岛市": 7.776940133037694,
    "兴城市": 11.323529411764707,
    "吉林": 7.40482720076944,
    "长春市": 4.600077529396563,
    "榆树市": 9.028534923339013,
    "德惠市": 18.767449238578678,
    "吉林市": 7.027643039691233,
    "蛟河市": 0.13513513513513514,
    "桦甸市": 6.564102564102564,
    "舒兰市": 4.4744,
    "磐石市": 6.4411764705882355,
    "四平市": 18.119516129032256,
    "双辽市": 4.365909090909091,
    "辽源市": 11.142116630669546,
    "通化市": 11.216375281287865,
    "集安市": 15.731343283582088,
    "白山市": 7.776119402985075,
    "临江市": 6.191044776119402,
    "松原市": 8.030626090327582,
    "扶余市": 3.2,
    "白城市": 10.101455668284075,
    "洮南市": 3.992467043314501,
    "大安市": 5.651282051282052,
    "延吉市": 8.310967741935483,
    "图们市": 11.702146690518784,
    "敦化市": 3.7652882935352356,
    "珲春市": 5.579106483036615,
    "龙井市": 10.333333333333334,
    "和龙市": 15.262948207171315,
    "公主岭市": 9.454545454545455,
    "梅河口市": 6.7765567765567765,
    "长白山保护开发区管理委员会": 18.199285714285715,
    "黑龙江": 8.419718788357004,
    "哈尔滨市": 5.290779017907677,
    "尚志市": 9.74296435272045,
    "五常市": 7.602996254681648,
    "齐齐哈尔市": 6.801931680988566,
    "讷河市": 6.780958721704394,
    "鸡西市": 9.979850746268655,
    "虎林市": 17.933572710951527,
    "密山市": 7.133264462809917,
    "鹤岗市": 11.728861330326946,
    "双鸭山市": 17.51609571354794,
    "大庆市": 11.815356121914885,
    "伊春市": 8.284183872224386,
    "铁力市": 16.345454545454544,
    "佳木斯市": 5.658131270903009,
    "同江市": 26.388888888888886,
    "富锦市": 5.760493827160493,
    "抚远市": 10.625,
    "七台河市": 12.723964497041422,
    "牡丹江市": 7.283560311284047,
    "海林市": 4.655367231638419,
    "宁安市": 12.631344612644702,
    "穆棱市": 13.780651340996169,
    "绥芬河市": 4.651606071302506,
    "东宁市": 6.614285714285715,
    "黑河市": 9.673,
    "北安市": 1.7704280155642025,
    "五大连池市": 19.572953736654803,
    "绥化市": 8.828888888888889,
    "安达市": 3.645418326693227,
    "肇东市": 3.4488095238095235,
    "海伦市": 16.692262256349675,
    "上海": 31.035338600998593,
    "江苏": 16.060351654619442,
    "南京市": 16.68548673215968,
    "无锡市": 13.713602844734618,
    "江阴市": 14.936,
    "宜兴市": 24.933365064255117,
    "徐州市": 10.706302985624768,
    "新沂市": 16.18559482060966,
    "邳州市": 11.936562626672071,
    "常州市": 13.720761762509335,
    "溧阳市": 19.836024844720495,
    "苏州市": 16.17582163570648,
    "常熟市": 14.455816326530613,
    "张家港市": 14.339300937766412,
    "昆山市": 7.255138888888889,
    "太仓市": 7.520611573446874,
    "南通市": 15.521471865193657,
    "海安市": 30.906832298136646,
    "启东市": 25.324324324324326,
    "如皋市": 26.550608272506082,
    "海门市": 28.9,
    "连云港市": 9.729551569506727,
    "淮安市": 22.07257894736842,
    "盐城市": 19.041341463414636,
    "东台市": 19.866756032171583,
    "扬州市": 22.13158354187278,
    "仪征市": 26.556517311608957,
    "高邮市": 17.097037037037037,
    "镇江市": 13.308117951950688,
    "丹阳市": 13.786012816940652,
    "扬中市": 15.706989247311826,
    "句容市": 21.106315789473683,
    "泰州市": 17.90937984496124,
    "兴化市": 13.83125,
    "靖江市": 20.01177163037081,
    "泰兴市": 16.49940828402367,
    "宿迁市": 14.310630171865053,
    "浙江": 17.721074033346007,
    "杭州市": 19.288092064627286,
    "建德市": 18.67924528301887,
    "宁波市": 11.202168478576828,
    "余姚市": 19.414127423822716,
    "慈溪市": 25.624468085106386,
    "温州市": 10.543703476325685,
    "瑞安市": 40.43478260869565,
    "乐清市": 7.82024882024882,
    "嘉兴市": 7.110326086956521,
    "海宁市": 17.81290322580645,
    "平湖市": 9.78609112709832,
    "桐乡市": 15.0324467344381,
    "湖州市": 30.95164020311115,
    "绍兴市": 13.166338160939242,
    "诸暨市": 11.219224283305227,
    "嵊州市": 34.844927536231886,
    "金华市": 11.636689629140324,
    "兰溪市": 23.296536796536795,
    "义乌市": 20.466910702244487,
    "东阳市": 36.51396906026322,
    "永康市": 34.40713727533212,
    "衢州市": 15.612126915837592,
    "江山市": 30.29714285714286,
    "舟山市": 33.63664404688464,
    "台州市": 24.523184416684312,
    "玉环市": 18.209212225570383,
    "温岭市": 9.668803418803419,
    "临海市": 16.7816091954023,
    "丽水市": 24.060913705583758,
    "龙泉市": 24.227450980392156,
    "安徽": 13.553619163175155,
    "合肥市": 12.589270386266096,
    "巢湖市": 12.9375,
    "芜湖市": 10.64245810055866,
    "蚌埠市": 10.786912751677852,
    "淮南市": 13.426356589147288,
    "马鞍山市": 20.163390170511533,
    "淮北市": 12.494354110207768,
    "铜陵市": 20.09899163797344,
    "安庆市": 11.393602362204724,
    "潜山市": 16.317948717948717,
    "桐城市": 8.643939393939394,
    "黄山市": 12.980668088130777,
    "滁州市": 11.599287225748968,
    "天长市": 15.104950495049504,
    "明光市": 22.944444444444443,
    "阜阳市": 12.45957142857143,
    "界首市": 10.467410714285714,
    "宿州市": 9.463291139240505,
    "六安市": 8.021628498727736,
    "亳州市": 13.076056338028168,
    "池州市": 18.104247104247104,
    "宣城市": 38.71655737704918,
    "宁国市": 9.378472222222223,
    "福建": 16.444076999634653,
    "福州市": 17.50001707358716,
    "福清市": 60.046319431097444,
    "厦门市": 10.871777754955325,
    "莆田市": 16.588850528025993,
    "三明市": 14.062910560889339,
    "永安市": 15.645615446500402,
    "泉州市": 14.769778761061946,
    "石狮市": 26.471881390593047,
    "晋江市": 17.5,
    "南安市": 9.370114942528735,
    "漳州市": 16.514230655203082,
    "龙海市": 13.10021413276231,
    "南平市": 11.903760614638092,
    "邵武市": 10.513835674755216,
    "武夷山市": 29.45821325648415,
    "建瓯市": 6.527950310559005,
    "龙岩市": 30.667746022807265,
    "漳平市": 8.994,
    "宁德市": 8.624358974358975,
    "福安市": 8.85670916818458,
    "福鼎市": 10.473991249392318,
    "江西": 12.836630429862058,
    "南昌市": 14.286144756277695,
    "景德镇市": 10.553073912042366,
    "乐平市": 12.122827804107425,
    "萍乡市": 12.064604008561977,
    "九江市": 11.97346600331675,
    "瑞昌市": 11.740384615384617,
    "共青城市": 8.48304347826087,
    "庐山市": 8.75,
    "新余市": 12.61875,
    "鹰潭市": 2.3415421881308034,
    "贵溪市": 8.165195460277427,
    "赣州市": 18.228127600554785,
    "瑞金市": 10.549229738780978,
    "吉安市": 17.18909710391823,
    "井冈山市": 4.4943820224719095,
    "宜春市": 13.327809307604996,
    "丰城市": 11.634766355140188,
    "樟树市": 7.132203389830508,
    "高安市": 7.519777322004101,
    "抚州市": 9.496810043218769,
    "上饶市": 10.877850363613954,
    "德兴市": 52.900763358778626,
    "山东": 9.670535565598943,
    "济南市": 8.797647979569138,
    "青岛市": 9.943054526130307,
    "胶州市": 7.414937081222423,
    "平度市": 8.785918459455393,
    "莱西市": 14.207536713771127,
    "淄博市": 10.134680371726274,
    "枣庄市": 9.11108250740121,
    "滕州市": 15.81302834410741,
    "东营市": 12.748184494602551,
    "烟台市": 10.211317049950912,
    "龙口市": 7.443946188340807,
    "莱阳市": 8.014664804469273,
    "莱州市": 5.506611258027956,
    "蓬莱市": 13.26635330983157,
    "招远市": 14.970588235294118,
    "栖霞市": 8.339181286549707,
    "海阳市": 12.456445993031359,
    "潍坊市": 10.36424798443147,
    "青州市": 15.198846153846155,
    "诸城市": 7.141941747572815,
    "寿光市": 6.925087108013937,
    "安丘市": 7.542337745176208,
    "高密市": 5.195612431444241,
    "昌邑市": 4.6984,
    "济宁市": 6.593256366440212,
    "曲阜市": 13.057407407407409,
    "邹城市": 9.3540206185567,
    "泰安市": 17.73849068519103,
    "新泰市": 11.873925501432664,
    "肥城市": 5.004607283896446,
    "威海市": 14.134081034656965,
    "荣成市": 17.959233449477356,
    "乳山市": 16.55972027972028,
    "日照市": 15.817524841915086,
    "莱芜市": 3.0095,
    "临沂市": 8.13095736661362,
    "德州市": 9.737161064600775,
    "乐陵市": 3.187878787878788,
    "禹城市": 8.713866666666668,
    "聊城市": 9.491707229132865,
    "临清市": 5.710191082802549,
    "滨州市": 7.555969101123595,
    "邹平市": 2.477627118644068,
    "菏泽市": 3.6889227952395482,
    "河南": 8.52019432885762,
    "郑州市": 8.890719223415209,
    "巩义市": 5.351445086705202,
    "荥阳市": 8.134095634095635,
    "新密市": 9.44636678200692,
    "新郑市": 10.605882352941178,
    "登封市": 3.065134099616858,
    "开封市": 13.095404521118382,
    "洛阳市": 8.021842522459044,
    "偃师市": 9.8093422306959,
    "平顶山市": 14.087193460490463,
    "舞钢市": 6.605087825560266,
    "汝州市": 8.099159663865546,
    "安阳市": 9.889770114942529,
    "林州市": 10.52420968387355,
    "鹤壁市": 9.222083593262633,
    "新乡市": 7.117184995190766,
    "卫辉市": 7.265154819014392,
    "辉县市": 16.506511001347103,
    "焦作市": 8.748984995586937,
    "沁阳市": 8.857142857142858,
    "孟州市": 12.67738095238095,
    "濮阳市": 6.943968253968254,
    "许昌市": 7.089439252336449,
    "禹州市": 6.73866090712743,
    "长葛市": 4.038461538461538,
    "漯河市": 8.615339145854884,
    "三门峡市": 4.886274509803921,
    "义马市": 7.498660953401178,
    "灵宝市": 4.743478260869565,
    "南阳市": 3.5082603254067584,
    "邓州市": 19.137142857142855,
    "商丘市": 8.115942028985508,
    "永城市": 7.3533190578158445,
    "信阳市": 12.946786248131541,
    "周口市": 5.052245768359323,
    "项城市": 9.652785438499725,
    "驻马店市": 6.180777777777777,
    "济源市": 9.580533865988741,
    "湖北": 9.148582311971058,
    "武汉市": 1.158053997291845,
    "黄石市": 11.107402912621358,
    "大冶市": 7.504468412942989,
    "十堰市": 5.885616015521651,
    "丹江口市": 14.089160839160838,
    "宜昌市": 13.080778368593732,
    "宜都市": 15.064054257724191,
    "当阳市": 27.77597672485453,
    "枝江市": 10.13894324853229,
    "襄阳市": 5.297336683417086,
    "老河口市": 10.081089847551088,
    "枣阳市": 5.2044280442804425,
    "宜城市": 9.089208633093525,
    "鄂州市": 17.118512780790088,
    "荆门市": 8.471917163476624,
    "钟祥市": 10.061381074168798,
    "孝感市": 10.607942238267148,
    "应城市": 13.245208568207442,
    "安陆市": 11.031706089582284,
    "汉川市": 10.603571428571428,
    "荆州市": 20.81652504472272,
    "石首市": 7.435283687943263,
    "洪湖市": 39.920634920634924,
    "松滋市": 18.25464190981432,
    "黄冈市": 7.46840291076216,
    "麻城市": 11.842849794238681,
    "武穴市": 16.17161716171617,
    "咸宁市": 9.708059784886157,
    "赤壁市": 13.180689655172413,
    "随州市": 12.841885907788486,
    "广水市": 13.315757575757576,
    "恩施市": 31.195999999999998,
    "利川市": 17.874736842105264,
    "仙桃市": 11.915737926376224,
    "潜江市": 18.086615643083814,
    "天门市": 25.0421511627907,
    "湖南": 13.49080636206277,
    "长沙市": 10.725117705025731,
    "宁乡市": 17.341040462427745,
    "浏阳市": 13.455172413793104,
    "株洲市": 21.984501440131673,
    "醴陵市": 26.008881578947367,
    "湘潭市": 9.548100949525237,
    "湘乡市": 33.72093023255814,
    "韶山市": 34.05940594059406,
    "衡阳市": 10.624119448698316,
    "耒阳市": 3.7367256637168142,
    "常宁市": 9.285714285714286,
    "邵阳市": 9.692307692307692,
    "武冈市": 20.586111111111112,
    "岳阳市": 13.738636363636363,
    "汨罗市": 15.31893520843797,
    "临湘市": 11.93849080532657,
    "常德市": 14.607282432561243,
    "津市市": 8.862586605080832,
    "张家界市": 17.19592570401438,
    "益阳市": 7.374087591240875,
    "沅江市": 8.502869066249348,
    "郴州市": 0.16310432569974556,
    "资兴市": 18.40633737185461,
    "永州市": 18.59502398081535,
    "怀化市": 16.4,
    "洪江市": 17.1875,
    "娄底市": 11.695906432748538,
    "冷水江市": 43.31798157789348,
    "涟源市": 1.4666666666666666,
    "吉首市": 17.989473684210527,
    "广东": 9.869594749066476,
    "广州市": 3.6144798886162413,
    "乐昌市": 11.583739837398374,
    "南雄市": 9.191304347826087,
    "深圳市": 18.14517867149446,
    "珠海市": 27.784304012454886,
    "汕头市": 13.465009763891356,
    "佛山市": 13.304888667744743,
    "江门市": 17.218722383537433,
    "台山市": 31.35859872611465,
    "开平市": 24.546323968918113,
    "鹤山市": 16.973872584108804,
    "恩平市": 4.9638554216867465,
    "湛江市": 14.158827232664807,
    "廉江市": 8.675324675324676,
    "雷州市": 13.891891891891893,
    "吴川市": 35.42578125,
    "茂名市": 11.862820727821566,
    "高州市": 6.723783783783784,
    "化州市": 1.452513966480447,
    "信宜市": 7.195571955719557,
    "肇庆市": 15.305707836181876,
    "四会市": 13.805309734513274,
    "惠州市": 9.640507147475038,
    "梅州市": 6.329711856400567,
    "兴宁市": 11.694394858978935,
    "汕尾市": 19.549440580586634,
    "陆丰市": 8.136363636363637,
    "河源市": 18.82688492063492,
    "阳江市": 12.73231622746186,
    "阳春市": 24.0,
    "清远市": 14.346847407038927,
    "英德市": 11.675272727272727,
    "连州市": 8.402923976608186,
    "东莞市": 3.905175835516393,
    "潮州市": 6.768357134825142,
    "揭阳市": 8.782302158273382,
    "普宁市": 6.885064351990422,
    "罗定市": 25.888212927756655,
    "广西": 13.106905966923447,
    "南宁市": 12.288160222390701,
    "柳州市": 11.616497330807645,
    "桂林市": 19.49095560021926,
    "荔浦市": 20.439560439560438,
    "梧州市": 6.9965573770491805,
    "岑溪市": 7.860663082437276,
    "北海市": 18.608885651857246,
    "防城港市": 10.630586305863057,
    "东兴市": 15.12672623883022,
    "钦州市": 11.16627996906419,
    "贵港市": 13.743244880649462,
    "桂平市": 4.806914893617021,
    "玉林市": 12.614266666666667,
    "北流市": 10.674245115452932,
    "百色市": 11.983816334211518,
    "靖西市": 6.747126436781609,
    "贺州市": 20.02796157950907,
    "河池市": 13.558429343992477,
    "来宾市": 20.81721279115673,
    "合山市": 13.758300132802123,
    "崇左市": 8.813428571428572,
    "凭祥市": 20.244274809160306,
    "海南": 17.499473046319228,
    "海口市": 6.395243302351012,
    "三亚市": 34.921750920007746,
    "三沙市": 3.3945578231292517,
    "儋州市": 40.170704845814974,
    "五指山市": 13.846153846153845,
    "琼海市": 34.445250181290795,
    "文昌市": 16.05426356589147,
    "万宁市": 39.84421809466746,
    "东方市": 2.807017543859649,
    "重庆": 11.519763215564701,
    "重庆市": 11.519763215564701,
    "四川": 13.431922127739478,
    "成都市": 16.607870499581356,
    "都江堰市": 12.873783854851432,
    "彭州市": 39.73917869034406,
    "邛崃市": 10.365135453474677,
    "崇州市": 9.172835532668168,
    "简阳市": 6.159722222222222,
    "自贡市": 24.988548387096774,
    "攀枝花市": 15.106354102405922,
    "泸州市": 11.644044731081001,
    "德阳市": 6.373935454952937,
    "广汉市": 5.278891724389355,
    "什邡市": 17.674418604651162,
    "绵竹市": 7.403030303030303,
    "绵阳市": 24.288614298323033,
    "江油市": 19.6,
    "广元市": 7.575097276264592,
    "遂宁市": 11.40719561591613,
    "内江市": 6.289285295153151,
    "隆昌市": 17.326190476190476,
    "乐山市": 13.014400622729632,
    "峨眉山市": 9.257602862254025,
    "南充市": 6.910344827586207,
    "阆中市": 7.228571428571429,
    "眉山市": 9.67546254170458,
    "宜宾市": 5.961953689226417,
    "广安市": 9.924340742786137,
    "华蓥市": 14.060038734667527,
    "达州市": 6.969092721834497,
    "万源市": 4.889322916666666,
    "雅安市": 13.649503397804496,
    "巴中市": 5.317674496085291,
    "资阳市": 9.96,
    "马尔康市": 7.79467680608365,
    "康定市": 12.037037037037036,
    "西昌市": 14.118274978650724,
    "贵州": 12.693861273322888,
    "贵阳市": 13.263252032520326,
    "清镇市": 9.767307692307693,
    "六盘水市": 14.760147601476014,
    "盘州市": 21.10185185185185,
    "遵义市": 20.142723631508677,
    "仁怀市": 27.98065843621399,
    "安顺市": 8.729046242774565,
    "铜仁市": 2.6586454492528624,
    "兴义市": 10.426054895534618,
    "兴仁市": 11.931868131868132,
    "凯里市": 10.00041203131438,
    "都匀市": 14.89894772006013,
    "福泉市": 9.081735620585267,
    "云南": 10.217247867213072,
    "昆明市": 8.414367646725456,
    "安宁市": 14.80449317999465,
    "曲靖市": 9.345039508340648,
    "宣威市": 3.7001594896331738,
    "玉溪市": 12.291775117126496,
    "保山市": 11.24418604651163,
    "腾冲市": 7.758007117437722,
    "昭通市": 8.322247191011236,
    "丽江市": 27.35375,
    "普洱市": 10.551698113207546,
    "临沧市": 1.4222222222222223,
    "楚雄市": 13.01277823577906,
    "个旧市": 10.486322188449847,
    "开远市": 9.547692307692309,
    "蒙自市": 23.644383394383397,
    "弥勒市": 13.02127659574468,
    "文山市": 20.36317204301075,
    "景洪市": 9.284671532846716,
    "大理市": 7.163406214039125,
    "瑞丽市": 13.211406844106465,
    "芒市": 12.06030150753769,
    "泸水市": 6.067172264355363,
    "香格里拉市": 1.2248520710059172,
    "西藏": 10.413698295350402,
    "拉萨市": 11.863860534464964,
    "日喀则市": 12.258741258741258,
    "昌都市": 11.235955056179774,
    "林芝市": 8.0,
    "山南市": 2.5069637883008355,
    "那曲市": 5.88160407383832,
    "陕西": 7.2256715184690625,
    "西安市": 6.5807858394972,
    "铜川市": 8.673694984646877,
    "宝鸡市": 11.557333894914182,
    "咸阳市": 9.130315500685871,
    "彬州市": 5.59601259181532,
    "兴平市": 2.295762341633901,
    "渭南市": 5.291642228739002,
    "韩城市": 16.373626373626376,
    "华阴市": 6.25,
    "延安市": 5.295121951219512,
    "汉中市": 8.390278516941637,
    "榆林市": 9.57450880326614,
    "神木市": 7.508532423208191,
    "安康市": 5.3164444444444445,
    "商洛市": 4.230769230769231,
    "杨凌区": 4.247422680412371,
    "甘肃": 6.375919942559683,
    "兰州市": 4.396141537346779,
    "嘉峪关市": 6.092329545454545,
    "金昌市": 6.2695454545454545,
    "白银市": 4.981412639405204,
    "天水市": 4.589285714285714,
    "武威市": 6.904691649454116,
    "张掖市": 9.159192825112108,
    "平凉市": 9.61404761904762,
    "华亭市": 2.5454545454545454,
    "酒泉市": 6.1960747663551405,
    "玉门市": 13.042749371332775,
    "敦煌市": 22.84943371085943,
    "庆阳市": 13.666666666666666,
    "定西市": 8.263283108643934,
    "陇南市": 5.0724637681159415,
    "临夏市": 11.835,
    "合作市": 3.226788432267884,
    "青海": 12.092567868268803,
    "西宁市": 13.781354166666667,
    "海东市": 5.510657193605684,
    "玉树市": 23.772791023842917,
    "格尔木市": 10.254490190660404,
    "德令哈市": 10.282272727272728,
    "宁夏": 5.302993838046432,
    "银川市": 4.360940305817054,
    "灵武市": 4.775075987841946,
    "宁东能源化工基地": 15.193333333333333,
    "石嘴山市": 5.379377431906615,
    "吴忠市": 5.653908942499546,
    "青铜峡市": 6.98613251155624,
    "固原市": 5.878231292517007,
    "中卫市": 3.9803125,
    "新疆": 8.287264524782053,
    "乌鲁木齐市": 4.948075748320098,
    "克拉玛依市": 13.494853523357087,
    "吐鲁番市": 16.460411899313502,
    "哈密市": 15.84574162679426,
    "昌吉市": 7.5970973339643475,
    "阜康市": 7.857206012378425,
    "博乐市": 12.355,
    "阿拉山口市": 18.570506912442397,
    "库尔勒市": 6.201098146877145,
    "阿克苏市": 5.807050092764379,
    "阿图什市": 5.016666666666667,
    "喀什市": 4.975831674722775,
    "和田市": 7.710890571950901,
    "伊宁市": 16.4372641509434,
    "奎屯市": 7.866318878382784,
    "霍尔果斯市": 23.099415204678362,
    "塔城市": 14.881681681681682,
    "乌苏市": 11.685224839400428,
    "阿勒泰市": 16.425625,
    "石河子市": 11.894115251476277,
    "阿拉尔市": 6.418918918918918,
    "图木舒克市": 7.36543909348442,
    "五家渠市": 1.535219747140277,
    "铁门关市": 26.371666666666666,
    "双河市": 2.2222222222222223,
    "可克达拉市": 8.44876886417792,
    "昆玉市": 56.80793507664563
}